import { cn } from "@/components/podkit/lib/cn";

export const containerClassName = cn(
    "flex items-center gap-2 h-9 w-full max-w-[600px] px-3 py-2",
    "rounded-lg border border-border-light text-base",
    "focus-within:ring-content-primary disabled:cursor-text",
    "focus-within:ring-4 focus-within:ring-ring-default focus-visible:ring-4 focus-visible:ring-ring-default",
    "group-data-[state=error]:border-border-error group-data-[state=error]:ring-ring-destructive disabled:bg-inherit bg-surface-primary",
    "read-only:bg-surface-muted read-only:border-border-light read-only:text-content-muted",
);

export const inputClassName = cn(
    "flex h-full w-full max-w-[600px] focus-visible:ring-0 text-base p-0 border-0 outline-none",
    "file:border-0 file:bg-transparent file:text-sm file:font-medium",
    "disabled:cursor-text",
    "placeholder:text-content-muted border-border-base disabled:bg-surface-primary text-content-primary bg-transparent",
    "read-only:bg-surface-muted read-only:cursor-default read-only:text-content-muted",
);

/**
 * When styling an input, use this classname to ensure that the input
 * is styled as per our design system. If styling a complex input (e.g. with a prefix, suffix or other nodes), use `inputClassName` and `containerClassName` to style the input and container separately.
 */
export const standaloneInputClassName = cn(inputClassName, containerClassName);
